<template>
  <Row type="flex" :align="align" :gutter="gutter" class="list-header">
    <Col v-for="(col, index) in config" :key="index" :lg="col.lg">
      <span>{{ col.prop }}</span>
    </Col>
  </Row>
</template>

<script>
import getConfig from "@/constants/tables/";
import { mapGetters } from "vuex";

export default {
  name: "ListHeader",
  props: {
    type: String,
    align: {
      type: String,
      default: "top"
    },
    gutter: {
      type: Number,
      default: 20
    }
  },
  computed: {
    ...mapGetters({
      userType: "getUserType"
    }),
    config() {
      return getConfig(this.type, this.userType).header;
    }
  }
};
</script>

<style scoped lang="scss">
.list-header {
  background: $blue-light;
  min-height: 40px;
  border-radius: 5px;
  span {
    color: $gray-dark;
    white-space: nowrap;
    font-size: 14px;
  }
}
</style>
